module.exports = __webpack_public_path__ + "img/page-04.b8333a43.png";